<template>
  <v-footer
    id="core-footer"
    
    height="82"
  >
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="tertiary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a href="#!">Grupo Insud</a>, Area de Sistemas
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { name: 'Home', Link: '/dashboard' },
      { name: 'Api', Link: '' },
      { name: 'Documentación', Link: '' },
      { name: 'Blog', Link: '' }
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
  position: relative;
}
</style>
